// @flow
/* eslint-disable react/no-multi-comp */
import styles from './SignInRegisterLink.less';

import classnames from 'classnames';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { stringify } from 'query-string';

import { signInRegUrlPrefix, signInPath, registerPath } from 'src/config';

import NavLink from 'src/components/NavLink/NavLink';
import { TextLink } from 'seek-style-guide/react';

export const LOGIN_MODES = {
  SIGN_IN: 'signin',
  REGISTER: 'register'
};

export const ANALYTICS_LOGIN_PREFIXES = {
  SIGN_IN: 'sign-in',
  REGISTER: 'register'
};

const modeToHref = {
  [LOGIN_MODES.SIGN_IN]: {
    href: `${signInRegUrlPrefix}${signInPath}`
  },
  [LOGIN_MODES.REGISTER]: {
    href: `${signInRegUrlPrefix}${registerPath}`
  }
};

function getReturnUrl(location: UrlLocation) {
  const { pathname, query } = location;
  const queryString = stringify(query || {});
  return `${pathname || ''}${queryString ? `?${queryString}` : ''}`;
}

const getUrl = (linkUrl, returnUrl) =>
  `${linkUrl}?returnUrl=${encodeURIComponent(returnUrl)}`;

type Props = {
  analytics?: string,
  children?: any,
  returnLocation?: UrlLocation,
  currentLocation: UrlLocation,
  mode: typeof LOGIN_MODES.SIGN_IN | typeof LOGIN_MODES.REGISTER,
  invert?: boolean
};

class SignInRegisterLink extends Component<Props> {
  constructor(props: Props) {
    super(props);

    this.mode = modeToHref[props.mode];
  }

  mode: { href: string };

  render() {
    const {
      children,
      currentLocation,
      returnLocation,
      invert,
      ...props
    } = this.props;
    const { href } = this.mode;
    const returnUrl = getReturnUrl(returnLocation || currentLocation);
    return (
      <NavLink
        component={TextLink}
        location={getUrl(href, returnUrl)}
        className={classnames({
          [styles.root]: true,
          [styles.invert]: invert
        })}
        {...props}
      >
        {children}
      </NavLink>
    );
  }
}

const mapStateToProps = ({ location }) => ({
  currentLocation: location
});

const SignInRegisterLinkContainer = props => <SignInRegisterLink {...props} />;

export { SignInRegisterLink as SignInRegisterLinkForTest };
export default connect(mapStateToProps)(SignInRegisterLinkContainer);
